// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";

const firebaseConfig = {
    apiKey: "AIzaSyCmwxdZeXuJTo3D_J6r-4tZYfLEgje9q3s",
    authDomain: "dinebahar-mern.firebaseapp.com",
    projectId: "dinebahar-mern",
    storageBucket: "dinebahar-mern.appspot.com",
    messagingSenderId: "99421399202",
    appId: "1:99421399202:web:63cfc8123f4874eb3f4ffb",
    measurementId: "G-G6ELZLBNM9"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const db = firebaseApp.firestore();
  const auth = firebase.auth();

  export { db, auth };



